import React from "react"

const About = () => (
  <div className="mt-12 md:mt-16">
    就労継続支援B型事業所は一般企業で働くことが難しい方に就労機会を提供する福祉サービスです。一定の支援を受けながら自分のペースで働けるため、体調に不安がある方でも安心して利用できます。利用者は事業者と雇用契約を結ばないため、心身の状態や年齢を理由に、毎日決まった時間に決められた時間まで仕事を行うことが難しい場合でも自分のペースで働くことが可能です。
  </div>
)

export default About
